/**
 * RIN_BASIC getColumnDefs1 결과 → 조회 전용 (편집·버튼형 셀은 텍스트 표시만)
 * 작성구분(isRisk) — '구분'(gubun) 컬럼 직전에 삽입, Chip(연한 배경 + 테두리)
 */
import React from 'react';
import { Chip } from '@mui/material';

const headerWrap = { wrapHeaderText: true, headerClass: 'ag-header-cell-wrap' };

function buildWriterGubunColumn() {
  return {
    colId: 'writerGubun',
    field: 'isRisk',
    headerName: '작성구분',
    width: 150,
    minWidth: 130,
    maxWidth: 200,
    sortable: true,
    resizable: true,
    editable: false,
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      paddingTop: 0,
      paddingBottom: 0,
    },
    cellRenderer: (params) => {
      const raw =
        params?.data?.isRisk ?? params?.data?.IsRisk ?? params?.value ?? '';
      const v = String(raw).trim().toUpperCase();
      let label = '—';
      let badgeSx = {
        fontWeight: 800,
        borderRadius: '999px',
        height: 'auto',
        py: 0.5,
        px: 1.25,
        m: 0,
        fontSize: 11,
        lineHeight: 1.25,
        bgcolor: '#f5f5f5',
        color: '#757575',
        border: '1px solid #e0e0e0',
        verticalAlign: 'middle',
        '& .MuiChip-label': { px: 0.75 },
      };
      if (v === 'Y') {
        label = '위험성평가하기';
        badgeSx = {
          ...badgeSx,
          bgcolor: 'rgba(44, 169, 0, 0.14)',
          color: '#217F00',
          border: '1px solid #2CA900',
        };
      } else if (v === 'N') {
        label = '안전신문고';
        badgeSx = {
          ...badgeSx,
          bgcolor: '#FFF8E1',
          color: '#E65100',
          border: '1px solid #FFB74D',
        };
      }
      return (
        <span
          style={{
            width: '100%',
            height: '100%',
            minHeight: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxSizing: 'border-box',
          }}
        >
          <Chip size="small" label={label} sx={badgeSx} />
        </span>
      );
    },
    valueFormatter: (p) => {
      const v = String(p.value ?? '')
        .trim()
        .toUpperCase();
      if (v === 'Y') return '위험성평가하기';
      if (v === 'N') return '안전신문고';
      return '';
    },
    ...headerWrap,
  };
}

export function GetWorkerOpinionReadOnlyColumnDefs(baseColumnDefs) {
  const strip = (cols) =>
    (cols || []).map((col) => {
      if (col.children && Array.isArray(col.children)) {
        return { ...col, children: strip(col.children) };
      }
      const next = { ...col, editable: false };
      delete next.checkboxProps;
      if (next.valueSetter) delete next.valueSetter;

      const f = next.field;
      /** 버튼행필드 */
      const noRendererFields = [
        'discovererNm',
        'gongjongNm',
        'managerNm',
        'preFileNames',
        'postFileNames',
      ];
      if (f && noRendererFields.includes(f)) {
        next.cellRenderer = undefined;
        next.cellRendererParams = undefined;
      }
      /** 조회 전용 팝업 — 구분·소속·작성자명 헤더의 필수(*) 표시 제거 */
      if (f && ['gubun', 'depNm', 'discovererNm'].includes(f)) {
        next.headerComponentParams = {
          ...(next.headerComponentParams || {}),
          required: false,
        };
      }
      /** 조회 전용 — 소속·직위·작성자명: 필수/편집불가 셀 배경·테두리 제거 */
      if (f && ['depNm', 'rank', 'discovererNm'].includes(f)) {
        delete next.cellClass;
        delete next.cellClassRules;
      }
      return next;
    });

  const stripped = strip(baseColumnDefs);
  const writerCol = buildWriterGubunColumn();
  const gubunIdx = stripped.findIndex(
    (c) =>
      c.field === 'gubun' || c.colId === 'gubun' || c.headerName === '구분'
  );
  if (gubunIdx === -1) {
    return [writerCol, ...stripped];
  }
  const next = [...stripped];
  next.splice(gubunIdx, 0, writerCol);
  return next;
}
